import React from 'react';
import {Modal} from 'react-bootstrap';
import {personFullName} from '../../../../../../services/Api';


const DeleteAdminUserModal = (props)=>{

    const { person, onHide, onConfirm }= props;

    return (
        <Modal
            show={true}
            onHide={onHide}>


            <Modal.Header closeButton>
                <Modal.Title>Eliminar usuario</Modal.Title>
            </Modal.Header>

            <Modal.Body >

                <p>¿Estás seguro que deseas eliminar al miembro <strong>{personFullName(person)}</strong>?</p>
                <p>Esta acción no puede deshacerse.</p>

            </Modal.Body>

            <Modal.Footer>
                <button onClick={ onHide } className='btn btn-primary pull-left'>Cancelar</button>
                <button className='btn btn-danger' onClick={ ()=>onConfirm( person ) }>Eliminar</button>
            </Modal.Footer>


        </Modal>
    );
};

export default DeleteAdminUserModal;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AdminUsers/components/DeleteAdminUserModal/index.js